module.exports = {
  siteTitle: 'Tannerthings | Troy Tanner - Technology Professional',
  siteDescription:
    'Troy Tanner is a technology professional based in Dayton, OH who specializes in business enablement through effective use of technology:',
  siteKeywords:
    'Tannerthings, tannerthings, Troy, Tanner, automation, devops, devsecops, consulting, continuous integration, continous development, continuous',
  siteUrl: 'https://tannerthings.com',
  siteLanguage: 'en_US',
  googleAnalyticsID: 'UA-163562022-1',
  googleVerification: 'QneUoWQSUVkQk_Vz219UXzwToYYl5WsJx9sSkEuD9j8',
  name: 'Tannerthings',

  location: 'Dayton, OH',
  email: 'troy.tanner@tannerthings',
  github: 'https://github.com/tannerthings',
  twitterHandle: '@tannerthings',
  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/tannerthings',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/tannerthings',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/tannerthings',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Tools',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  navHeight: 100,

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
